/* global unitsData, calculationUrl */

let refreshTimeOut;

export function addUnit() {
    if ($('.unitHidden').length) {
        $('.unitHidden').first().css('display', 'block').removeClass('unitHidden');

        if ($('.unitHidden').length < 1) {
            $('#addUnit').hide();
        }

        refreshPersonNumber();
    }
}

export function refreshPersonNumber() {
    if ($('.unitHidden').length < 1) {
        $('#addUnit').hide();
    }

    let selectedUnitsNum = 0;

    $('.unit-persons').hide();

    $('select[id$=_selected] option').prop('disabled', false);

    $('select[id$=_selected]').each(function updatePersonSelectElement() {
        const self = $(this);

        if (self.val()) {
            $('select[id$=_selected]').each(function disableOptionsExceptSelected() {
                if ($(this).attr('id') !== self.attr('id')) {
                    $(this).find(`option[value=${self.val()}]`).prop('disabled', true);
                }
            });
        }

        if (!self.parents('.unitHidden').length && self.val() && !self.prop('disabled')) {
            selectedUnitsNum += 1;
            self.parents('.unitRow').find('.unit-persons').show();

            const unitCapacity = parseInt(unitsData[self.val()].capacityBasic, 10)
                + parseInt(unitsData[self.val()].capacityAdditional, 10);
            const personSelect = self.parents('.unitRow').find('.unit-persons').find('select');

            const personNumberSelected = personSelect.val();

            personSelect.prop('disabled', false).find('option').remove();

            for (let personNum = 1; personNum <= unitCapacity; personNum += 1) {
                personSelect.append(`<option value="${personNum}">${personNum}</option>`);
            }

            personSelect.val(personNumberSelected);
        }
    });

    if (selectedUnitsNum < 2) {
        $('.unit-persons').hide();
        $('.unit-persons').find('select').prop('disabled', true);
    }
}

export function bindChange() {
    $(document).on('change', 'input[id$="_od"], input[id$="_do"], '
        + 'input[id^="ReservationLighthouseSingleForm_brojosoba_"], '
        + 'select[id$=selected], select[id$="_persons"], '
        + 'select[id$="_g_type"], select[id$="_popusti_starigost_brojusluga"], '
        + 'input[id$="_popusti_starigost_usluge"], input[id$="_recomm_g"], input[id$="user_register_email"]', preCheck);
}

export function preCheck() {
    if (refreshTimeOut) {
        clearTimeout(refreshTimeOut);
    }

    refreshTimeOut = setTimeout(checkPrice, 500);
}

export function checkPrice() {
    $('.reservationLoader').show();
    $.post(calculationUrl, $('.reservationForm').serialize(), (response) => {
        $('#olgGuestServicesLabel').hide();
        $('#guestTypeLabel').show();
        const submitButton = document.getElementById('submitReservationForm');

        if (response.detailCalculation) {
            document.getElementById('detailCalculation').innerHTML = response.detailCalculation;
        }

        if (response && response.status === 'error') {
            submitButton.disabled = true;
            submitButton.classList.add('gray');
            renderErrorMessages(response.errors);
        }

        if (response && response.status === 'success') {
            submitButton.disabled = false;
            submitButton.classList.remove('gray');

            if (response.userData.oldGuest.count !== '' && response.userData.oldGuest.isOldGuest) {
                $('#ReservationLighthouseSingleForm_g_type').val('popusti_starigost').hide();
                $('#olgGuestServicesLabel').show();
                $('#guestTypeLabel').hide();
                $('#ReservationLighthouseSingleForm_popusti_starigost_brojusluga').val(response.userData.oldGuest.count);
                $('#ReservationLighthouseSingleForm_popusti_starigost_usluge').val(response.userData.oldGuest.services);
                guestTypeChange();
            }
        }

        if (document.getElementById('consent')) {
            document.getElementById('consent').style.display = response.userData.hasConsent ? 'none' : 'block';
        }

        if (document.getElementById('newsletter')) {
            document.getElementById('newsletter').style.display = response.userData.isUserSubscribedToNewsletter ? 'none' : 'block';
        }

        $('.reservationLoader').hide();
    });
}

function renderErrorMessages(response, errorList) {
    let first = false;
    let errorMessages = errorList;
    if (errorList === undefined) {
        errorMessages = $('<ul />');
        first = true;
    }

    $.each(response, (id, value) => {
        if (value instanceof Object) {
            renderErrorMessages(value, errorMessages);
        } else {
            errorMessages.append($('<li />').html(value));
        }
    });

    if (first) {
        $('.calculationMessages').each(function appendErrorMessage() {
            $(this).html(errorMessages.html());
        });

        $('.reservationTotalPrice').html('?');

        if ($('#ReservationPrivateSingleForm_p_type').length > 0) {
            $('#paymentMethodMessage').hide();
        }
    }
}

export function sidebarScroll() {
    const tmpWindow = $(window);
    const tmpSWrapper = $('#serviceWrapper');
    let calcOffsetBottom;
    const sideCalculation = $('#sideCalculation');
    const calcOffsetTop = sideCalculation.offset().top - 20;

    tmpWindow.scroll(() => {
        calcOffsetBottom = tmpSWrapper.height() - sideCalculation.height();
        if (tmpWindow.scrollTop() < calcOffsetTop) {
            sideCalculation.removeClass('fixedCalculation bottomCalculation');
        } else if (tmpWindow.scrollTop() > calcOffsetBottom) {
            sideCalculation.removeClass('fixedCalculation').addClass('bottomCalculation');
        } else {
            sideCalculation.removeClass('bottomCalculation').addClass('fixedCalculation');
        }
    });
}

export function guestTypeChange() {
    const guestType = $('#ReservationLighthouseSingleForm_g_type').val();

    $('.returningGuestRow, .recommendingRow, .recommendingCodeRow').hide();

    if (guestType === 'popusti_starigost') {
        $('.returningGuestRow').show();
    } else if (guestType === 'recomm') {
        $('.recommendingRow').show();
    } else if (guestType === 'recomm_camp') {
        $('.recommendingCodeRow').show();
    }
}

/**
 * Dohvaća dostupne termine za dane jedinice svjetionika.
 *
 * @return {string} JSON podaci
 */
export function getAvailableDates(url) {
    return $.post(url, { selectedUnits: getSelectedUnits() });
}

/**
 * Odlučuje da li je datum u datepickeru klikabilan (dostupan ili nedostupan).
 *
 * @param {object} dt Datum
 * @param {array} availableDays Niz dostupnih dana po mjesecima i godinama @see LighthouseAvailabilityService::findAvailableDays()
 *
 * @return {array} Sadrži:
 *         - (bool) da li je datum klikabilan
 *         - (string) CSS klasa koju treba primijeniti na polje datuma u datepickeru
 */
export function datepickerSetDayAvailabilityCallback(dt, availableDays) {
    const cssClass = getCSSClass(dt);
    const isSafari = window.safari !== undefined;
    let available = false;
    if (availableDays[dt.getFullYear()] !== undefined) {
        const monthDays = availableDays[dt.getFullYear()][dt.getMonth() + 1];
        if (monthDays !== undefined) {
            monthDays.some((day) => {
                let availableDay = new Date(day.date);
                if (isSafari) {
                    availableDay = dateForSafari(day.date, 'yyyy/mm/dd');
                }
                if (areDatesSame(availableDay, dt)) {
                    available = true;
                }
                return available;
            });
        }
    }

    return [available, cssClass];
}

function areDatesSame(a, b) {
    return (
        a.getFullYear() === b.getFullYear()
        && a.getMonth() === b.getMonth()
        && a.getDate() === b.getDate()
    );
}

function getCSSClass(dt) {
    let selectedCssClass = '';
    const time = dt.getTime();
    const dateFrom = $('.lighthouseDateFrom').datepicker('getDate');
    const dateTo = $('.lighthouseDateTo').datepicker('getDate');

    if (dateFrom && time === dateFrom.getTime()) {
        selectedCssClass = 'unavail_temp_start';
    }

    if (dateTo && time === dateTo.getTime()) {
        selectedCssClass = 'unavail_temp_end';
    }

    if (dateFrom && dateTo && time > dateFrom.getTime() && time < dateTo.getTime()) {
        selectedCssClass = 'unavail_temp';
    }

    return selectedCssClass;
}

/**
 * Dohvaća jedinice selektirane u rezervacijskoj formi.
 *
 * @return {array}
 */
function getSelectedUnits() {
    const visibleUnitRows = document.querySelectorAll('.unitRow:not(.unitHidden)');

    const units = [];
    visibleUnitRows.forEach((unitRow) => {
        const unitSelect = unitRow.querySelector("select[id^='ReservationLighthouseSingleForm_units']");
        const selectedUnit = unitSelect.options[unitSelect.selectedIndex].value;
        units.push(selectedUnit);
    });

    return units;
}

function dateForSafari(input, format) {
    const newFormat = format || 'yyyy-mm-dd';
    const parts = input.match(/(\d+)/g);
    let i = 0;
    const fmt = {};
    // eslint-disable-next-line no-plusplus
    newFormat.replace(/(yyyy|dd|mm)/g, (part) => { fmt[part] = i++; });

    return new Date(parts[fmt.yyyy], parts[fmt.mm] - 1, parts[fmt.dd]);
}
